// Badge.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Badge = ({ id, icon, bgColor }) => {
  const badgeStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '70px',
    height: '70px',
    borderRadius: '35px',
    fontSize: '24px',
    color: '#fff',
    textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
    backgroundColor: bgColor,
  };

  return (
    <div className="badge" id={id} style={badgeStyle}>
      <FontAwesomeIcon icon={icon} />
    </div>
  );
};

export default Badge;
